export { default } from 'ember-animated/services/motion';
